import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Navbar from '../../Common/Navbar/Navbar';
import Footer from '../../Common/Footer/Footer';
import './Product.css';
import GradientBtn from '../../Common/GradientBtn/GradientBtn';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

function Product() {
    const isDark = useSelector((state) => state.functionslice.value.isDark);
    const smallScreen = useMediaQuery("(max-width:600px)");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className={`product-main-container ${isDark ? 'dark-theme' : ''}`}>
            <Navbar />
            {/* Header */}
            <header className="product-header">
                {smallScreen ? <><h1>Built in India, for<br /> <span className="highlight-green">India's Roads</span></h1></> : <><h1>Built in India, for <span className="highlight-green">India's Roads</span></h1></>}
                <p>Revolutionary AI solutions designed specifically for Indian traffic conditions and infrastructure</p>
            </header>
            {/* Product 1: TransitEye (Left Image, Right Text) */}
            <section className="product-section">
                <div className="product-image-container">
                    <img src="/Images/CoverImages/transiteye-cover.png" alt="TransitEye Dashboard" />
                </div>
                <div className="product-content-container">
                    <h2>TransitEye</h2>
                    <p>Empowering Urban Transit with Live Passenger Counts, Continuous Surveillance, and Location Intelligence to Make Every Journey Safer, Smarter and Comfortable</p>
                    <ul className="product-features-list">
                        <li><span className="check-icon">✓</span> Real-time edge computing</li>
                        <li><span className="check-icon">✓</span> Passenger Information System</li>
                        <li><span className="check-icon">✓</span> Revenue Loss Protection</li>
                    </ul>
                    <Link to="/products/transiteye">
                        <GradientBtn className="product-cta-button">Explore Feature</GradientBtn>
                    </Link>
                </div>
            </section>

            {/* Product 2: TrafficEye (Right Image, Left Text - Reverse) */}
            <section className="product-section reverse">
                <div className="product-image-container">
                    <img src="/Images/CoverImages/trafficeye-cover.jpg" alt="TrafficEye App" />
                </div>
                <div className="product-content-container">
                    <h2>TrafficEye</h2>
                    <p>AI powered, camera-based edge device designed for live traffic analysis capable of vehicle counting, turning movement detection, speed measurement, traffic violation monitoring, surrogate safety assessment, and comprehensive traffic flow analysis.</p>
                    <ul className="product-features-list">
                        <li><span className="check-icon">✓</span> Real-time edge computing</li>
                        <li><span className="check-icon">✓</span> Customizable Battery Backup</li>
                        <li><span className="check-icon">✓</span> Site Ready Plug and Play</li>
                    </ul>
                    <Link to="/products/trafficeye">
                        <GradientBtn className="product-cta-button">Explore Feature</GradientBtn>
                    </Link>
                </div>
            </section>

            {/* Product 3: CrowdEye (Left Image, Right Text) */}
            <section className="product-section">
                <div className="product-image-container">
                    <img src="/Images/CoverImages/crowdeye-cover.png" alt="CrowdEye Dashboard" />
                </div>
                <div className="product-content-container">
                    <h2>CrowdEye</h2>
                    <p>AI-powered edge analytics system that monitors crowd density, movement patterns, and safety risks in real time, enabling authorities to manage events, public spaces, and emergency situations efficiently.</p>
                    <ul className="product-features-list">
                        <li><span className="check-icon">✓</span> Real Time Crowd Detection</li>
                        <li><span className="check-icon">✓</span> Plug & Play Installation</li>
                        <li><span className="check-icon">✓</span> Crowd Monitoring & Alerts</li>
                    </ul>
                    <Link to="/products/crowdeye">
                        <GradientBtn className="product-cta-button">Explore Feature</GradientBtn>
                    </Link>
                </div>
            </section>

            {/* Product 4: Video Analytics (Right Image, Left Text - Reverse) */}
            <section className="product-section reverse">
                <div className="product-image-container">
                    <img src="/Images/CoverImages/video-analytics-cover.png" alt="Video Analytics" />
                </div>
                <div className="product-content-container">
                    <h2>Video Analytics</h2>
                    <p>Advanced software transforms raw video feeds into actionable insights,delivering real-time analytics for turning movements, traffic flow, lane behavior,ANPR,violation detection, and safety assessments all aligned with Indo-HCM standards.Optimize road performance, enhance safety, and enable data-driven decision-making with cutting-edge AI-powered solutions.</p>
                    <ul className="product-features-list">
                        <li><span className="check-icon">✓</span> Traffic and Crowd Analytics</li>
                        <li><span className="check-icon">✓</span> Robust Dataset</li>
                        <li><span className="check-icon">✓</span> Novel Indian Dataset</li>
                    </ul>
                    <Link to="/products/video-analytics">
                        <GradientBtn className="product-cta-button">Explore Feature</GradientBtn>
                    </Link>
                </div>
            </section>

            {/* Comparison Table
            <section className="comparison-section">
                <h2>Product Comparison</h2>
                <div className="comparison-table-container">
                    <table className="comparison-table">
                        <thead>
                            <tr>
                                <th>Features</th>
                                <th>Transiteye</th>
                                <th>Trafficeye</th>
                                <th>Crowdeye</th>
                                <th>Video Analytics</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Transiteye</td>
                                <td data-label="Real-time Monitoring"><span className="comparison-check">✓</span></td>
                                <td data-label="AI-Powered Predictions"><span className="comparison-check">✓</span></td>
                                <td data-label="Mobile Integration"><span className="comparison-cross">✗</span></td>
                                <td data-label="Emergency Response"><span className="comparison-check">✓</span></td>
                                <td data-label="Cost Reduction"><span className="comparison-value">40%</span></td>
                            </tr>
                            <tr>
                                <td>Trafficeye</td>
                                <td data-label="Real-time Monitoring"><span className="comparison-check">✓</span></td>
                                <td data-label="AI-Powered Predictions"><span className="comparison-cross">✗</span></td>
                                <td data-label="Mobile Integration"><span className="comparison-check">✓</span></td>
                                <td data-label="Emergency Response"><span className="comparison-cross">✗</span></td>
                                <td data-label="Cost Reduction"><span className="comparison-value">60%</span></td>
                            </tr>
                            <tr>
                                <td>Crowdeye</td>
                                <td data-label="Real-time Monitoring"><span className="comparison-check">✓</span></td>
                                <td data-label="AI-Powered Predictions"><span className="comparison-check">✓</span></td>
                                <td data-label="Mobile Integration"><span className="comparison-cross">✗</span></td>
                                <td data-label="Emergency Response"><span className="comparison-check">✓</span></td>
                                <td data-label="Cost Reduction"><span className="comparison-value">35%</span></td>
                            </tr>
                            <tr>
                                <td>Video Analytics</td>
                                <td data-label="Real-time Monitoring"><span className="comparison-check">✓</span></td>
                                <td data-label="AI-Powered Predictions"><span className="comparison-check">✓</span></td>
                                <td data-label="Mobile Integration"><span className="comparison-check">✓</span></td>
                                <td data-label="Emergency Response"><span className="comparison-cross">✗</span></td>
                                <td data-label="Cost Reduction"><span className="comparison-value">25%</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section> */}

            {/* Legend Section
            <section className="product-legend-section">
                <div className="legend-item">
                    <span className="comparison-check">✓</span>
                    <span>Available</span>
                </div>
                <div className="legend-separator">•</div>
                <div className="legend-item">
                    <span className="comparison-cross">✗</span>
                    <span>Not available</span>
                </div>
            </section> */}

            {/* CTA Section */}
            <section className="product-cta-section">
                <h2>Ready to Transform Your City?</h2>
                <p>Join leading cities and organizations across India in revolutionizing urban mobility with our AI-powered solutions.</p>
                <Link to="/contact">
                    <GradientBtn className="product-cta-btn">Partner with Us</GradientBtn>
                </Link>
            </section>

            {/* Footer is included via <Footer /> */}
            <Footer />
        </div>
    );
}

export default Product;
